"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _list = _interopRequireDefault(require("webmotors-react-pj/frame/menu/list"));
var _userOptions = _interopRequireDefault(require("webmotors-react-pj/frame/menu/user-options"));
var _style = _interopRequireWildcard(require("webmotors-react-pj/frame/menu/style"));
var _v = _interopRequireDefault(require("webmotors-react-pj/tag-analytics/v2"));
var _context = _interopRequireDefault(require("./context"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = _ref => {
  let {
    opened,
    setOpened,
    setPinnedMenu,
    pinnedMenu
  } = _ref;
  const [showPin, setShowPin] = (0, _react.useState)(Boolean(localStorage.getItem('PinnedMenu')));
  const context = {
    get: {
      pinnedMenu,
      showPin
    }
  };
  const handleFixedMenu = () => {
    setPinnedMenu(prevState => !prevState);
    if (pinnedMenu === false) {
      localStorage.setItem('PinnedMenu', true);
      (0, _v.default)('pj_cockpit_menufixarMenu');
    } else {
      localStorage.removeItem('PinnedMenu');
    }
  };
  return _react.default.createElement(_context.default.Provider, {
    value: context
  }, _react.default.createElement(_style.default, {
    opened: opened,
    showPin: showPin,
    pinnedMenu: pinnedMenu,
    onMouseOver: () => !pinnedMenu && setShowPin(true),
    onMouseLeave: () => !pinnedMenu && setShowPin(false)
  }, _react.default.createElement(_style.StyleMenuHeader, null, _react.default.createElement(_style.StyleLogo, {
    showPin: showPin,
    pinnedMenu: pinnedMenu
  }), _react.default.createElement(_style.StylePin, {
    showPin: showPin,
    pinnedMenu: pinnedMenu,
    onClick: () => handleFixedMenu()
  }), _react.default.createElement(_style.StyleClose, {
    onClick: () => setOpened(false),
    "data-qa": "menuClose"
  })), _react.default.createElement(_style.StyleUserOptions, null, _react.default.createElement(_userOptions.default, {
    opened: opened,
    setOpened: setOpened
  })), _react.default.createElement(_list.default, null)));
};
exports.default = _default;